import React from 'react'
import "./HomePage.css"
import Home from '../../Components/Home/Home'
import CategoryOfBooks from '../../Components/Used&NewBooks/CategoryOfBooks'
import Footer from '../../Components/Footer/Footer'


const HomePage = () => {
  return (
    <div>
      <Home/>
    </div>
  )
}


export default HomePage